module.exports = __webpack_public_path__ + "static/media/log_banner.6f705617.png";